import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { AboutSection } from './components/AboutSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-navy-50 selection:bg-gold-200 selection:text-navy-900" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <PainSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <AboutSection data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}